
import { application } from './application'

import LocationController from './location_controller'
import LocationCardController from './location_card_controller'
import MapController from './map_controller'
import SearchController from './search_controller'

application.register('map', MapController)
application.register('search', SearchController)
application.register('location', LocationController)
application.register('location-card', LocationCardController)
